import { __require as t } from "./lib/ReactPlayer.js";
import { __require as i } from "./lib/players/YouTube.js";
var e, a;
function l() {
  if (a) return e;
  a = 1;
  var u = t().createReactPlayer, r = i().default;
  return e = u([{
    key: "youtube",
    canPlay: r.canPlay,
    lazyPlayer: r
  }]), e;
}
export {
  l as __require
};
